var map = {
	"./bg_1.jpg": "9dac",
	"./bg_2.jpg": "94ff",
	"./bg_3.jpg": "51ee",
	"./bg_4.jpg": "821b",
	"./bg_5.jpg": "a22f",
	"./bg_6.jpg": "35a8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0de2";